import { ApiService } from '../apiService'
import type {
  ActiveDaysDto,
  MostActiveFriendDto,
  MostActiveFriendsSort,
  RecentAchievementProgressDto,
  StreaksDto,
  TimeZoneSettingsDto,
} from '../types/baseCamp'

/**
 * Minutes east of UTC (getTimezoneOffset is minutes WEST) — sent the same way as the step history
 * endpoint. The server prefers the stored IANA zone and falls back to this.
 */
const offsetMinutes = () => -new Date().getTimezoneOffset()

/** Endpoints behind the Base Camp widgets (Backlog 046 §5.2–§5.4). All are self-only. */
export const baseCampApi = {
  /** Active local days in [from, to] (yyyy-MM-dd, inclusive, ≤ 400 days). Only active days are listed. */
  getActiveDays: (from: string, to: string) =>
    ApiService.get<ActiveDaysDto>('/api/me/activity/days', { from, to, offsetMinutes: offsetMinutes() }),

  /** All four streak periods, computed on read in the user's zone. */
  getStreaks: () => ApiService.get<StreaksDto>('/api/me/streaks', { offsetMinutes: offsetMinutes() }),

  /** The `count` (1–5) most recently progressed achievements, system and collection mixed. */
  getRecentAchievementProgress: (count: number) =>
    ApiService.get<RecentAchievementProgressDto[]>('/api/me/achievements/recent-progress', { count }),

  /** Friends with visible activity in the window. Friends with nothing visible are simply absent. */
  getMostActiveFriends: (days: number, limit: number, sort: MostActiveFriendsSort) =>
    ApiService.get<MostActiveFriendDto[]>('/api/me/friends/most-active', { days, limit, sort }),

  getTimeZone: () => ApiService.get<TimeZoneSettingsDto>('/api/me/settings/time-zone'),

  /** 400 when the id is not a known IANA zone. */
  setTimeZone: (timeZoneId: string) =>
    ApiService.put<TimeZoneSettingsDto>('/api/me/settings/time-zone', { timeZoneId }),
}
